// TODO: Think of a better place for this
// Lazy import for code splitting
import { lazy } from "react";
import { Navigate, createBrowserRouter, useLocation } from "react-router-dom";

const TravelThemePage = lazy(() => import("pages/TravelTheme"));
const ComposeTripPage = lazy(() => import("pages/ComposeTrip"));
const PassengersPage = lazy(() => import("pages/Passengers"));
const SummaryPage = lazy(() => import("pages/Summary"));
const ConfirmationPage = lazy(() => import("pages/Confirmation"));
const FarePage = lazy(() => import("pages/Fare"));

const RedirectWithQuery = () => {
  const location = useLocation();
  const searchParams = location.search;
  return <Navigate to={`/travel-theme${searchParams}`} />;
};

// react-router-dom@6.4
// https://reactrouter.com/en/main/routers/create-browser-router
const Router = createBrowserRouter([
  {
    path: "/",
    element: <RedirectWithQuery />,
  },
  {
    path: "/travel-theme",
    element: <TravelThemePage />,
  },
  {
    path: "/compose-trip",
    element: <ComposeTripPage />,
  },
  {
    path: "/passengers",
    element: <PassengersPage />,
  },
  {
    path: "/summary",
    element: <SummaryPage />,
  },
  {
    path: "/confirmation",
    element: <ConfirmationPage />,
  },
  {
    path: "/fare",
    element: <FarePage />,
  },
]);

export default Router;
